import TimedTransaction from "parog-web/models/timed-transaction";

export default async function performTimedTransaction<
  T,
  F extends () => Promise<T>
>(name: string, timedTransactions: TimedTransaction[], func: F): Promise<T> {
  const timedTransaction = new TimedTransaction(name, new Date());
  return new Promise(async (resolve, reject) => {
    try {
      const result = await func();
      timedTransaction.success = true;
      resolve(result);
    } catch (error) {
      timedTransaction.success = false;
      timedTransaction.error = { name: error.name, message: error.message };
      reject(error);
    } finally {
      timedTransaction.endDate = new Date();
      timedTransactions.push(timedTransaction);
    }
  });
}
